import { getAxiosClient } from '../../api';

export const deleteUserFormat = async (formatId) => {
  const httpClient = await getAxiosClient();
  const tableName = 'editor_project_formats';
  const url = `${process.env.PARSE_API_URL}/${tableName}/${formatId}`;
  const method = 'DELETE';

  return httpClient({ url, method, responseType: 'json' });
};
